"use client";

import Image from "next/image";
import Slider from "react-slick";
import Section from "../Section";
const styles = new Proxy({"Resources":"Resources-3cdd9","SmallTitle":"SmallTitle-3cdd9","ResourcesSlide":"ResourcesSlide-3cdd9","CaseStudies":"CaseStudies-3cdd9","Card":"Card-3cdd9"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./Resources.scss";*/

interface ImageProps {
  url: string;
  width: number;
  height: number;
  alt?: string;
}

interface SliderItem {
  title: string;
  description: string;
  linkSrc: string;
  linkLabel: string;
  downloadLink?: boolean;
  image: ImageProps;
}

interface ResourceSectionProps {
  title: string;
  id: string;
  smallTitle?: string;
  sliderItems: SliderItem[];
}

interface PapersClientProps {
  papers: ResourceSectionProps[];
}

const SLIDER_SETTINGS = {
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  speed: 750,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnFocus: true,
  cssEase: "ease",
};

const PapersClient: React.FC<PapersClientProps> = ({ papers }) => {
  return (
    <>
      {papers.map((paper) => {
        const { title, id, sliderItems, smallTitle } = paper;
        return (
          <Section
            title={title}
            className={styles.Resources}
            maxWidth={1020}
            id={id}
            key={id}
          >
            {smallTitle && (
              <div className="row">
                <div className="col-12">
                  <p className={styles.SmallTitle}>
                    (The ones that are not Trade Secrets)
                  </p>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-12 resources-slider">
                <Slider {...SLIDER_SETTINGS}>
                  {sliderItems.map((item) => (
                    <div className={styles.ResourcesSlide}>
                      <div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                        <a
                          href={item.linkSrc}
                          rel={item.downloadLink ? "" : "noreferrer"}
                          target={item.downloadLink ? "" : "_blank"}
                          download={item.downloadLink}
                          className="ButtonPrimary"
                        >
                          {item.linkLabel}
                        </a>
                      </div>
                      <div>
                        <Image
                          src={item.image.url}
                          alt={item.image.alt || ""}
                          width={item.image.width}
                          height={item.image.height}
                          className="w-full h-auto"
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </Section>
        );
      })}
    </>
  );
};

export default PapersClient;
